import { useEffect } from 'react';
import { useCalibration } from '../../context/calibrationContext';
import { PatientWaiting } from '../session/PatientWaiting';

const ResponsivePleaseWait = () => {
  const {
    updateCalibrationData,
    calibrationData: { patientUsingResponsiveView },
  } = useCalibration();

  useEffect(() => {
    if (patientUsingResponsiveView) return;
    updateCalibrationData({ patientUsingResponsiveView: true });
  }, [updateCalibrationData, patientUsingResponsiveView]);

  // P2 / P7 waiting screens in the IBISengage design (screens/session/PatientWaiting).
  return <PatientWaiting />;
};

export default ResponsivePleaseWait;
